<ng-container
  *ngIf="{
    trackerContent: trackerFacadeData | ngrxPush,
    errors: trackerFacadeError | ngrxPush
  } as content"
>
  <aura-tracker
    *ngIf="content.trackerContent.earnometer"
    [content]="content.trackerContent"
    (redirect)="redirect($event)"
  ></aura-tracker>
  <aura-error-message
    *ngIf="content.errors.message"
    [content]="content.errors"
    (redirect)="redirect($event)"
  ></aura-error-message>
  <div *ngIf="spinner" class="spinner-overlay"></div>
  <div *ngIf="spinner" class="spinner-loading">
    <div class="loader-holder"></div>
    <h2>Loading...</h2>
  </div>
</ng-container>
